import { useAppDispatch, useAppSelector } from 'hooks';
import {
  selectIsCsatPromptableForEndLiveChat,
  selectPersistedLiveChatComponents,
  setCsatStatesByKey,
} from 'reducers/workflows';
import { useHandleConversationResolved } from './useHandleConversationResolved';
import { useEffect } from 'react';
import type { WidgetComponent } from 'api/types';
import { isEventMessageComponent } from 'api/types';

export const useResolveLiveChatConversation = () => {
  const dispatch = useAppDispatch();
  const persistedLiveChatComponents = useAppSelector(
    selectPersistedLiveChatComponents,
  );
  const isCsatPromptable = useAppSelector(selectIsCsatPromptableForEndLiveChat);
  const handleConversationResolved = useHandleConversationResolved();

  useEffect(() => {
    const shouldResolveConversation = getShouldResolveConversation(
      persistedLiveChatComponents,
    );
    if (shouldResolveConversation) {
      if (isCsatPromptable) {
        dispatch(
          setCsatStatesByKey({
            actionToExecuteAfterCsatDismiss: 'handle-live-chat-resolved',
            isCsatVisible: true,
            triggeredFrom: 'end-live-chat',
          }),
        );
      } else {
        handleConversationResolved(true);
      }
    }
  }, [
    dispatch,
    handleConversationResolved,
    isCsatPromptable,
    persistedLiveChatComponents,
  ]);
};

const getShouldResolveConversation = (
  liveChatComponents: WidgetComponent[] | null,
) => {
  const lastComponent =
    liveChatComponents && liveChatComponents[liveChatComponents.length - 1];
  if (lastComponent && isEventMessageComponent(lastComponent)) {
    return lastComponent.isConversationResolver;
  }
};
